import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const services = [
  {
    image: require("../../images/projects/image1.jpg"),
    title: "Projet Vallée Val d’Or 1",
    description:
      "Le Projet « VAL D’OR 1 », qui s’étale sur une superficie de 3 hectares environ, est initié par l’association la Vallée en partenariat avec  une amicale ayant les mêmes objectifs.",
  },
  {
    image: require("../../images/projects/image2.jpg"),

    title: "Projet Vallée Val d’Or 2",
    description:
      "Le Projet « VAL D’OR 2 », qui s’étale sur une superficie de 3 hectares environ, est initié par l’association la Vallée en partenariat avec  une amicale ayant les mêmes objectifs.",
  },
  {
    image: require("../../images/projects/image3.jpg"),
    title: "Projet Vallée Val d’Or 3",
    description:
      "Le Projet « VAL D’OR 3 », qui s’étale sur une superficie de 3 hectares environ, est initié par l’association la Vallée en partenariat avec  une amicale ayant les mêmes objectifs.",
  },
];

var bgimg1 = require("./../../images/background/cross-line2.png");

class SimilarProjects extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: false,
      center: false,
      items: 3,
      margin: 40,
      nav: true,
      dots: true,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 1,
        },
        991: {
          items: 1,
        },
      },
    };
    return (
      <>
        <div className="section-full p-tb40 bg-white inner-page-padding">
          <div className="container">
            <div className="section-content">
              {/* TITLE START */}
              <div className="section-head">
                <div className={`${this.props.alignment} sx-separator-outer`}>
                  <div
                    className="sx-separator bg-white bg-moving bg-repeat-x"
                    // style={{ backgroundImage: 'url(' + bgimg1 + ')' }}
                  >
                    <h3 className="sep-line-one">{this.props.title}</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
              <div className="work-carousel-outer">
                <OwlCarousel
                  className="owl-carousel mfp-gallery project-carousel project-carousel1 owl-btn-vertical-center"
                  {...options}
                >
                  {services.map((item, index) => (
                    <div key={index} className="item">
                      <div
                        className="sx-box   image-single-carousel bg-cover"
                        style={{ backgroundImage: "url(" + item.image + ")" }}
                      >
                        <div className="sx-info  p-t20 text-white">
                          <h4 className="sx-tilte m-t0">
                            <NavLink to={"/projects/valle-or-1"}>
                              {item.title}
                            </NavLink>
                          </h4>
                          <p>{item.description}</p>
                          <NavLink
                            to={"/projects/valle-or-1"}
                            className="site-button btn-half button-sm"
                            style={{ background: "#fff" }}
                          >
                            <span style={{ color: "#000" }}>Voir plus</span>
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
          <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>Projets</strong>
          </div>
        </div>
      </>
    );
  }
}

export default SimilarProjects;
